// This file is generated by a script. Do not edit this file directly.
(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react);
    global.Scale = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.Scale = void 0;
  _react = _interopRequireDefault(_react);
  function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
  function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
  var Scale = _exports.Scale = function Scale(props) {
    return /*#__PURE__*/_react["default"].createElement("svg", _extends({
      viewBox: "0 0 20 20",
      fill: "none"
    }, props), /*#__PURE__*/_react["default"].createElement("g", {
      "clip-path": "url(#clip0_8528_27846)"
    }, /*#__PURE__*/_react["default"].createElement("path", {
      d: "M13.1723 0.77002H18.3642C18.8437 0.77002 19.2295 1.1558 19.2295 1.63533V6.82721C19.2295 7.17694 19.0204 7.49422 18.6959 7.62762C18.3714 7.76102 18.0001 7.68891 17.7513 7.44014L16.3452 6.034L13.2084 9.17076C12.8695 9.50968 12.3215 9.50968 11.9861 9.17076L10.8324 8.01701C10.4935 7.6781 10.4935 7.13007 10.8324 6.79476L13.9692 3.658L12.5594 2.24826C12.3106 1.99948 12.2385 1.62812 12.3719 1.30363C12.5053 0.979137 12.8226 0.77002 13.1723 0.77002ZM6.82672 19.23H1.63484C1.15532 19.23 0.769531 18.8442 0.769531 18.3647V13.1728C0.769531 12.8231 0.978648 12.5058 1.30314 12.3724C1.62763 12.239 1.999 12.3111 2.24777 12.5599L3.65391 13.966L6.79066 10.8293C7.12958 10.4904 7.67761 10.4904 8.01292 10.8293L9.16667 11.983C9.50558 12.3219 9.50558 12.87 9.16667 13.2053L6.02991 16.342L7.43604 17.7482C7.68482 17.9969 7.75693 18.3683 7.62353 18.6928C7.49012 19.0173 7.17284 19.2264 6.82311 19.2264L6.82672 19.23Z",
      fill: "currentColor"
    })), /*#__PURE__*/_react["default"].createElement("defs", null, /*#__PURE__*/_react["default"].createElement("clipPath", {
      id: "clip0_8528_27846"
    }, /*#__PURE__*/_react["default"].createElement("rect", {
      width: "20",
      height: "20",
      fill: "currentColor"
    }))));
  };
});
